import * as Mui from "@mui/material";
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import 'dayjs/locale/es'; 
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from "dayjs";
import { DatePickerProps } from "./Types";
import { destructProps, useFormInputs } from "./Utils";

const FormDatePicker = (props: DatePickerProps) => {
  // const { error, helperText, fullWidth, ...baseProps} = props;
  const { formProps, baseProps } = destructProps<DatePickerProps>(props);

  const form = useFormInputs(formProps);

  const error = baseProps.error || !!form?.error;
  const helperText = baseProps.helperText || form?.error?.message?.toString() || "";

  // DEFAULTS
  const inputFormat = baseProps.inputFormat || "DD/MM/YYYY HH:mm";

  const onChange = (val: any) => {
    const dayjsVal = dayjs(val);
    if (form?.onChange) {
      if (val === null) {
        form.onChange(null);
        return;
      } 

      if (dayjsVal.isValid()){
        form.onChange(dayjsVal.toISOString());
      } else {
        form.onChange("invalid");
      }
    }
  }

  const removeTime = baseProps.removeTime || false;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {
         !!removeTime  ? (

          <DatePicker
            renderInput={(props) => (
                <Mui.TextField
                    {...props}
                    fullWidth={baseProps.fullWidth}
                    error={error}
                    helperText={helperText}
                />
            )}
            value={form?.value}
            onChange={(val) => onChange(val)}
            inputFormat={inputFormat}
            {...baseProps}
          />
          
        ) : (
          <DateTimePicker
              renderInput={(props) => (
                  <Mui.TextField
                      {...props}
                      fullWidth={baseProps.fullWidth}
                      error={error}
                      helperText={helperText}
                  />
              )}
              value={form?.value}
              onChange={(val) => onChange(val)}
              inputFormat={inputFormat}
              ampm={props.ampm || false}
              {...baseProps}
          />
        )
      }
    </LocalizationProvider>
  )
}

export default FormDatePicker;